import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IJobTypeData } from "common/records/JobType";

export const FETCH_JOB_TYPE = "@jobType/FETCH_JOB_TYPE";
export const RECEIVE_JOB_TYPE = "@jobType/RECEIVE_JOB_TYPE";
export const RECEIVE_JOB_TYPES = "@jobType/RECEIVE_JOB_TYPES";
export const RESET_JOB_TYPE = "@jobType/RESET_JOB_TYPE";
export const SET_JOB_TYPE_LOADED = "@jobType/SET_JOB_TYPE_LOADED";
export const DESTROY_JOB_TYPE = "@jobType/DESTROY_JOB_TYPE";
export const REMOVE_JOB_TYPE = "@jobType/REMOVE_JOB_TYPE";
export const ACTIVATE_JOB_TYPE = "@jobType/ACTIVATE_JOB_TYPE";

export const JobTypeActions = {
  fetchJobType: (jobTypeId: number) => createAction(FETCH_JOB_TYPE, { jobTypeId }),
  receiveJobType: (jobType: IJobTypeData, pushToList?: boolean) =>
    createAction(RECEIVE_JOB_TYPE, { jobType, pushToList }),
  receiveJobTypes: (jobTypes: IJobTypeData[]) => createAction(RECEIVE_JOB_TYPES, { jobTypes }),
  resetJobType: (jobTypeId: number) => createAction(RESET_JOB_TYPE, { jobTypeId }),
  setJobTypeLoaded: (jobTypeId: number) => createAction(SET_JOB_TYPE_LOADED, { jobTypeId }),
  destroyJobType: (jobTypeId: number) => createAction(DESTROY_JOB_TYPE, { jobTypeId }),
  removeJobType: (jobTypeId: number) => createAction(REMOVE_JOB_TYPE, { jobTypeId }),
  activateJobType: (jobTypeId: number) => createAction(ACTIVATE_JOB_TYPE, { jobTypeId }),
};

export type JobTypeActions = ActionsUnion<typeof JobTypeActions>;
